<template>
    <select :id="id" class="form-control" v-model="value">
    </select>
</template>

<script>
  import axios from "axios";
  export default {
    name: "Select2Ajax",
    props: {
      modelValue: [String, Number, Object],
      id: {
        type: String,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      options: {
        type: Object
      },
      placeholder: {
        type: String,
        default: '(Не выбрано)'
      },
      minimumInputLength: {
        type: Number,
        default: 3
      }
    },
    template: '#select2ajax-template',
    emits: ['update:modelValue', 'input'],
    mounted() {
      $(this.$el).select2({
        ajax: {
          transport: (params, success, failure) => {
            axios.get(this.url, {params: {term: params.data.term}})
              .then(success)
              .catch(failure);
          },
          ataType: 'json',
          delay: 500,
          cache: true,
          data: function (params) {
            return {
              term: params.term,
              _type: 'query',
              q: params.term
            };
          },
          processResults: function (response) {
            const resultData = $.map(response.data, function (obj) {
              return obj;
            });
            return {
              results: resultData
            };
          }
        },
        language: 'ru',
        placeholder: {
          id: '',
          text: this.placeholder
        },
        allowClear: this.options.allowClear || true,
        selectionTitleAttribute: false,
        minimumInputLength: this.minimumInputLength,
        templateResult: function (data) {
          return data.text;
        },
        templateSelection: function (data) {
          return data.text;
        },
        initSelection: (element, callback) => {
          const data = {
            id: this.value || '',
            text: this.options?.text || ''
          };
          callback(data);
        },
        escapeMarkup: function (markup) {
          return markup;
        }
      })
        .val(this.value)
        .trigger('change')
        .on('change', () => {
          this.value = $(this.$el).val();
          this.$emit('input', this.value);
        });
      if (this.options.forceSelect) {
        setTimeout(() => {
          $(this.$el).append(new Option(this.options.text || '', this.value || '', true, true));
        }, 500);
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue;
        },
        set (value) {
          this.$emit('update:modelValue', value);
        }
      }
    }
  }
</script>

<style lang="scss">
    .select2-container {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box;
        display: block;
        margin: 0;
        position: relative;
        vertical-align: middle
    }

    .select2-container--default .select2-selection--single {
        height: calc(2.25rem + 2px) !important;
    }

    .select2-container--default .select2-selection--single .select2-selection__arrow {
        top: 7px !important;
    }
</style>